import dynamic from "next/dynamic";
import ColoredTimerVerticalTabsConfig from "./colored-timer-vertical-tabs-config";
import ColoredTimerVerticalTabsAdvancedConfig from "./colored-timer-vertical-tabs-advanced-config";
const ColoredTimerVerticalTabsComponent = dynamic(()=>import("./colored-timer-vertical-tabs-component"));
export default {
    ColoredTimerVerticalTabsComponent,
    ColoredTimerVerticalTabsConfig,
    ColoredTimerVerticalTabsAdvancedConfig
};
